import { ServiceRequestConfig } from '~/services/createService';
import { k2 } from '~/services/serviceInstances';

import {
  CreateWorkflowApiArg,
  CreateWorkflowApiResponse,
  WorkflowDefinition,
} from '../../types/k2/workflows';

type Request = {
  workflowDefinition: WorkflowDefinition;
};

type ServerRequest = CreateWorkflowApiArg;
type ServerResponse = CreateWorkflowApiResponse;

export const createWorkflowK2 = async (
  request: Request,
  options: ServiceRequestConfig = {},
) => {
  const params = mapParams(request);

  const serverResponse: ServerResponse = await k2.post(
    '/workflows',
    params.createWorkflowRequest,
    { showErrorToast: true, ...options },
  );

  return mapResponse(serverResponse);
};

const mapParams = (request: Request): ServerRequest => {
  return {
    createWorkflowRequest: {
      data: {
        type: 'workflows',
        attributes: {
          workflow_definition: request.workflowDefinition,
        },
      },
    },
  };
};

const mapResponse = (serverResponse: ServerResponse) => {
  if (serverResponse === null) {
    return null;
  }

  return { id: serverResponse.data.id, ...serverResponse.data.attributes };
};
